var _path, _path2, _rect, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 72,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 43.5182C15.7889 43.5182 11.8175 46.9296 11.8175 53.1241C11.8175 53.6079 12.2096 54 12.6934 54H33.3066C33.7904 54 34.1825 53.6079 34.1825 53.1241C34.1825 46.9299 30.2111 43.5182 23 43.5182ZM13.6012 52.2482C13.9457 47.6166 17.1034 45.2701 23 45.2701C28.8967 45.2701 32.0543 47.6166 32.3992 52.2482H13.6012V52.2482Z",
    fill: "#00A094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30C19.6876 30 17.1898 32.548 17.1898 35.9267C17.1898 39.4044 19.7962 42.2333 23 42.2333C26.2038 42.2333 28.8102 39.4044 28.8102 35.927C28.8102 32.548 26.3124 30 23 30ZM23 40.4818C20.762 40.4818 18.9416 38.4385 18.9416 35.927C18.9416 33.5078 20.6485 31.7518 23 31.7518C25.3139 31.7518 27.0584 33.5466 27.0584 35.927C27.0584 38.4385 25.2379 40.4818 23 40.4818Z",
    fill: "#00A094"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 104,
    height: 69,
    rx: 5.5,
    stroke: "#00A094",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 53,
    x2: 97,
    y2: 53,
    stroke: "#00A094",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 79,
    y2: 12,
    stroke: "#00A094",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21,
    x2: 79,
    y2: 21,
    stroke: "#00A094",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 39,
    x2: 97,
    y2: 39,
    stroke: "#00A094",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 46,
    x2: 97,
    y2: 46,
    stroke: "#00A094",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicence);
export default __webpack_public_path__ + "static/media/licence.6c9f4266c3be25d943f9b0dce57df02e.svg";
export { ForwardRef as ReactComponent };